/**
 * @module StepReferenciaPago
 * @description Paso 2 del flujo de pagos en línea.
 * Muestra el nombre completo del titular (consultado en el paso anterior)
 * y renderiza el componente DocumentoPago para la selección de documentos pendientes.
 *
 * DocumentoPago solo se renderiza cuando stepIndex === 2 para optimizar rendimiento,
 * evitando consultas innecesarias y renderizados de listas grandes en otros pasos.
 */

import { FC } from "react";
import { usePagosOnline } from "../PagosOnlineContext";
import { DocumentoPago } from "../DocumentoPago";

const StepReferenciaPago: FC = () => {
  const { estado, stepIndex } = usePagosOnline();

  return (
    <div data-kt-stepper-element="content">
      <div className="w-100">
        {/* Encabezado con nombre completo del titular consultado */}
        <div className="row rounded-2" id="nombre-detalle">
          <span className="fw-bold">
            A nombre de:
            <span className="ml-4 fs-4 fw-bolder">
              {" " + estado.nombres + " " + estado.apellidos}
            </span>
          </span>
        </div>

        {/* Listado de documentos agrupados por servicio de venta (solo paso 2) */}
        {stepIndex === 2 ? (
          <DocumentoPago />
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export { StepReferenciaPago };
